import React from 'react';
import PropTypes from 'prop-types';
import { Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import { NumericFormat } from 'react-number-format';

export default function ProductDetails(props) {
    return (
        <div>
            <p>You and your family have dreams and goals that may change over time, but protecting your family and loved ones will always be important. Secure Promise is simplified issue permanent life insurance with fixed premiums and guaranteed death benefit protection.</p>
            <ul>
                <li>Issue ages: 14 days – 17 years</li>
                <li>Coverage amounts available: $10,000 - $75,000</li>
                <li>No medical exam required</li>
                <li>Fixed premiums</li>
            </ul>

            <p>This permanent, Whole Life Insurance policy provides guaranteed protection for the life of the contract. The following features are automatically included in your policy at no additional cost:</p>
            <ul>
                <li>Get early access to a portion of your death benefit coverage in the event of your terminal illness. <strong>The Accelerated Benefit for Terminal Illness Agreement (ABA)</strong> is included in your policy for no additional charge and with no effect on premium amount.</li>
                <li>Ensure your protection remains in force even if you miss a payment. <strong>The Automatic Premium Loan (APL) Provision</strong> allows a policy loan to be taken from your policy to pay the premium due and guarantee the contract will not lapse. The Automatic Premium Loan can only be effective if your policy has available loan value</li>
            </ul>

            <p>You also have the flexibility to increase your coverage amount, without the need for underwriting, for an additional cost. Provided you are under the age of 32, the <strong>Guaranteed Insurability Option (GIO) Agreement</strong> allows you to add additional coverage by providing a new policy each time you exercise this feature. The new policy will have a new premium and your original premium will remain the same. This feature can be exercised at the ages 25, 28, 31, and 34, or upon your date of marriage, or the birth or adoption of a child.  </p>
            <Button variant="text" color="secondary" onClick={props.setProductInfoDialogOpen}>View detailed product information</Button>

            <p><strong>Cash Values</strong></p>

            <TableContainer>
                <Table aria-label="Cash Value">
                    <TableHead>
                        <TableRow className="cash-value-header">
                            <TableCell>Year 5</TableCell>
                            <TableCell>Year 10</TableCell>
                            <TableCell>Year 20</TableCell>
                            <TableCell>Year 30</TableCell>
                            <TableCell>At Age 65</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        <TableRow key={0}>
                            {props.cashValues.map((cashValue, index) =>
                                <TableCell key={index} component="th" scope="row" className="text-center">
                                    <NumericFormat value={cashValue} displayType={'text'} thousandSeparator={true} prefix={'$'} />
                                </TableCell>
                            )}
                        </TableRow>
                    </TableBody>
                </Table>
            </TableContainer>

            <p><small className='fw-bolder'>Not FDIC/NCUA Insured; Not Bank Or Credit Union Guaranteed; Not A Deposit; Not Insured By Any Federal Government Agency.</small></p>

        </div>
    )
}

ProductDetails.propTypes = {
    cashValues: PropTypes.array.isRequired
};
